import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../../Dashboard";

export const userSegmentsRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "user-groups",
}).lazy(() => import("./index.lazy").then((d) => d.Route));
